import Sider from 'antd/es/layout/Sider'
import {
  DARK_MODE,
  WHITE_COLOR,
  CHARCOAL_NAVY_COLOR,
  COMET_COLOR,
  CHARCOAL_BLUE_COLOR,
  LIGHT_GRAY_COLOR,
  GUNMETAL_COLOR,
  TRANSPARENT,
  AZURE_RADIANCE_COLOR,
  BRAND_BLUE,
  BRIGHT_GREY_COLOR,
} from './constants'
import {
  BLACK_COLOR,
  BLACK_COLOR_2_OPACITY,
  BLACK_COLOR_88_OPACITY,
  BRIGHT_LIGHT_BLUE_COLOR,
  COLOR_SELECT_OPEN_LIGHT,
  DUST_RED_COLOR,
  ERROR_COLOR,
  ICE_BLUE_COLOR,
  LIGHT_BLUE,
  BRIGHT_WARNING_COLOR,
  LIGHTER_GRAY_COLOR,
  LIGHTEST_GRAY_COLOR,
  OFF_GREY_COLOR,
  RUST_BLUE_COLOR,
  VIVID_GREEN_COLOR,
  DARK_WARNING_COLOR,
  WHITE_COLOR_88_OPACITY,
} from './constants/colors'
import { Input, Layout, List } from 'antd'

export const themeComponentCreator = (theme) => {
  if (theme == DARK_MODE) {
    return {
      Card: {
        colorBgContainer: CHARCOAL_BLUE_COLOR,
        colorBorderSecondary: COMET_COLOR,
        headerPadding: 16,
      },
      Popover: {
        zIndexPopup: 8000,
        colorBgElevated: CHARCOAL_NAVY_COLOR,
        colorBorder: COMET_COLOR,
      },
      Pagination: {
        itemActiveBg: WHITE_COLOR,
        colorBgContainer: '',
      },
      Layout: {
        headerBg: CHARCOAL_NAVY_COLOR,
        bodyBg: RUST_BLUE_COLOR,
        siderBg: CHARCOAL_NAVY_COLOR,
      },
      Button: {
        colorBgContainer: CHARCOAL_NAVY_COLOR,
        defaultHoverBg: CHARCOAL_NAVY_COLOR,
        colorPrimary: WHITE_COLOR,
        primaryColor: CHARCOAL_NAVY_COLOR,
        colorPrimaryHover: LIGHT_GRAY_COLOR,
        colorBorder: COMET_COLOR,
      },
      /* Radio: {
        buttonBg: CHARCOAL_NAVY_COLOR,
        buttonSolidCheckedBg: WHITE_COLOR,
        buttonSolidCheckedColor: COMET_COLOR,
        colorPrimaryHover: LIGHT_GRAY_COLOR,
      }, */
      Table: {
        colorBgContainer: CHARCOAL_NAVY_COLOR,
        colorBorderSecondary: COMET_COLOR,
        headerBg: CHARCOAL_NAVY_COLOR,
        headerColor: WHITE_COLOR,
        headerSplitColor: TRANSPARENT,
        borderColor: COMET_COLOR,
        cellPaddingBlock: 4,
        cellPaddingInline: 8,
      },
      Spin: {
        colorPrimary: 'rgba(255, 255, 255, 0.45)',
      },
      Modal: {
        contentBg: GUNMETAL_COLOR,
        headerBg: GUNMETAL_COLOR,
      },
      /* Tabs: {
        itemColor: LIGHT_GRAY_COLOR,
        itemSelectedColor: WHITE_COLOR,
        boxShadowSecondary: 'none',
      },
      Carousel: {
        colorBgContainer: WHITE_COLOR,
      },
      Drawer: {
        colorBgElevated: CHARCOAL_NAVY_COLOR,
      }, */
      Tooltip: {
        colorBgSpotlight: BLACK_COLOR_88_OPACITY,
        colorTextLightSolid: WHITE_COLOR,
      },
      /* Badge: {
        colorTextLightSolid: BLACK_COLOR,
      }, */
      Menu: {
        itemBg: CHARCOAL_NAVY_COLOR,
        itemSelectedBg: LIGHT_BLUE,
        itemSelectedColor: WHITE_COLOR_88_OPACITY,

        itemHoverBg: 'transparent',

        subMenuItemBg: CHARCOAL_NAVY_COLOR,
        subMenuItemSelectedColor: WHITE_COLOR_88_OPACITY,
      },
      Input: {
        colorBgContainer: CHARCOAL_NAVY_COLOR,
        colorBorder: COMET_COLOR,
        hoverBorderColor: LIGHT_GRAY_COLOR,
      },
      Select: {
        colorBgContainer: CHARCOAL_NAVY_COLOR,
        colorBgElevated: CHARCOAL_NAVY_COLOR,
        colorBorder: COMET_COLOR,
        hoverBorderColor: LIGHT_GRAY_COLOR,
      },
      Message: {
        contentBg: CHARCOAL_NAVY_COLOR,
        colorInfo: WHITE_COLOR,
        colorSuccess: VIVID_GREEN_COLOR,
        colorWarning: DARK_WARNING_COLOR,
        colorError: DUST_RED_COLOR,
      },
      List: {
        colorBorder: COMET_COLOR,
        colorSplit: COMET_COLOR,
        headerBg: CHARCOAL_NAVY_COLOR,
        borderRadiusLG: 6,
        itemPadding: '7px 0',
        paddingLG: 16
      },
    }
  } else {
    return {
      Popover: {
        zIndexPopup: 8000,
        colorBgElevated: WHITE_COLOR,
        colorBorder: OFF_GREY_COLOR,
      },
      Card: {
        colorBgContainer: WHITE_COLOR,
        colorBorderSecondary: LIGHT_GRAY_COLOR,
        headerPadding: 16,
      },
      Layout: {
        headerBg: WHITE_COLOR,
        bodyBg: LIGHTEST_GRAY_COLOR,
        siderBg: WHITE_COLOR,
      },
      Table: {
        headerBg: LIGHTER_GRAY_COLOR,
        headerColor: CHARCOAL_NAVY_COLOR,
        headerSplitColor: TRANSPARENT,
        borderColor: OFF_GREY_COLOR,
        cellPaddingBlock: 4,
        cellPaddingInline: 8,
      },
      Spin: {
        colorPrimary: 'rgba(0, 0, 0, 0.88)',
      },
      Tabs: {
        itemColor: LIGHT_GRAY_COLOR,
        itemSelectedColor: BLACK_COLOR,
      },
      Button: {
        colorPrimary: BRAND_BLUE,
        colorBorder: OFF_GREY_COLOR,
      },
      /* Radio: {
        colorPrimary: BRAND_BLUE,
      },
      Carousel: {
        colorBgContainer: BLACK_COLOR,
      }, */
      Tooltip: {
        colorBgSpotlight: BLACK_COLOR_88_OPACITY,
        colorTextLightSolid: WHITE_COLOR,
      },
      Menu: {
        itemBg: WHITE_COLOR,
        itemColor: BLACK_COLOR_88_OPACITY,

        itemHoverBg: 'transparent',

        itemSelectedBg: ICE_BLUE_COLOR,
        itemSelectedColor: BRIGHT_LIGHT_BLUE_COLOR,

        subMenuItemBg: BLACK_COLOR_2_OPACITY,
        subMenuItemSelectedColor: BLACK_COLOR_88_OPACITY,
      },
      Input: {
        colorBorder: OFF_GREY_COLOR,
        hoverBorderColor: COLOR_SELECT_OPEN_LIGHT,
      },
      Select: {
        colorBorder: OFF_GREY_COLOR,
        hoverBorderColor: COLOR_SELECT_OPEN_LIGHT,
      },
      Message: {
        contentBg: WHITE_COLOR,
        colorInfo: AZURE_RADIANCE_COLOR,
        colorSuccess: VIVID_GREEN_COLOR,
        colorWarning: BRIGHT_WARNING_COLOR,
        colorError: ERROR_COLOR,
      },
      List: {
        colorBorder: OFF_GREY_COLOR,
        colorSplit: OFF_GREY_COLOR,
        headerBg: OFF_GREY_COLOR,
        borderRadiusLG: 6,
        itemPadding: '7px 0',
        paddingLG: 16
      },
    }
  }
}
